export const keys = {
  appMsg: 'appMsg',
  organization: {
    update: 'archempower_organization_update',
    refreshParent: 'archempower_organization_refresh_parent'
  },
  place: {
    update: 'archempower_place_update',
    refreshParent: 'archempower_place_refresh_parent'
  },
  account: {
    update: 'update_account'
  }
}

const MessageType = {
  success: 'success',
  warning: 'warning',
  info: 'info',
  error: 'error'
}

let store
const use = (s) => {
  store = s
}

class Message {
  constructor (code, message, type) {
    this.code = code
    this.message = message
    this.type = type
  }

  async firesync (key = keys.appMsg) {
    if (store) store.commit(key, this)
  }

  async fireAsync (key = keys.appMsg) {
    if (store) store.dispatch(key, this)
  }

  copy () {
    let cp = new Message(this.code, this.message, this.type)
    Object.assign(cp, this)
    return cp
  }
}

Message.success = (code, message) => new Message(code, message, MessageType.success)
Message.warning = (code, message) => new Message(code, message, MessageType.warning)
Message.info = (code, message) => new Message(code, message, MessageType.info)
Message.error = (code, message) => new Message(code, message, MessageType.error)

export const messages = {
  use: use,
  create: Message,
  success: Message.success,
  warning: Message.warning,
  error: Message.error,
  info: Message.info,
  // warning
  unauthorized: Message.warning(401, '登录信息异常，请重新登录'),
  nologininfo: Message.warning(402, '您还未登录，请先登录'),
  tokeninvalidate: Message.warning(1001, '登录信息已过期，请重新登录'),
  noidtoken: Message.warning(1002, '您还未登录，请先登录'),
  noaccessauth: Message.warning(403, '没有访问权限'),
  notenantinfo: Message.warning(405, '租户信息失效，请重新登录'),
  unhealthyserver: Message.error(503, '服务异常'),
  // error
  errornetwork: Message.error(801, '网络异常'),
  errordataparse: Message.error(802, '数据出错，请稍后再试'),
  errorunkown: Message.error(888, '未知错误，请稍后再试')
}



// WEBPACK FOOTER //
// ./src/utils/messages.js